"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_guid_1 = require("dyna-guid");
exports.createDynamicDynaNodeAddress = function () { return 'ddna--' + dyna_guid_1.guid(); };
//# sourceMappingURL=createDynamicDynaNodeAddress.js.map